
import { computed, defineComponent, ref, watch } from "vue";
import { MutationTypes, useStore } from "@/store";
import { VIEWPORT_TYPE } from "@/configs/viewport";
// 引入接口
import { EditorService } from "@/api/editor";

import router from "@/router";
import { useRoute } from "vue-router";
import { message } from "ant-design-vue";
export default defineComponent({
  name: "Sidebar",
  setup() {
    const store = useStore();
    const visible = computed(() => store.state.createDesignModalState);
    const collapse = ref(true);
    const sucaiCollapse = ref(false);
    const scenesList = ref([]);
    const viewportType = VIEWPORT_TYPE;
    const currViewportType = ref("px");
    const currViewportW = ref("");
    const currViewportH = ref("");
    const currRouter = ref(router.currentRoute.value);
    const categoryList = ref([]);
    const route = useRoute();
    watch(
      () => route.path,
      () => {
        currRouter.value.path = route.path;
      }
    );
    watch(
      () => visible.value,
      () => {
        if (visible.value) {
          getScenesList();
        }
      }
    );
    const showCreateDesign = () => {
      store.commit(MutationTypes.SET_CRATED_DESIGN_MODAL_STATE, true);
      getScenesList();
    };
    const closeModal = () => {
      store.commit(MutationTypes.SET_CRATED_DESIGN_MODAL_STATE, false);
    };
    const onCollapseOpeate = () => {
      router.push("/templates");
    };
    const onSucaiCollapseOpeate = () => {
      router.push("/material");
    };
    // console.log(scenes, 'scenes')
    const onCreateDesign = () => {
      if (currViewportW.value === "" || currViewportH.value === "") {
        message.error("请填写尺寸！");
        return;
      }
      router.push(
        "/editor?mode=" +
          "create&unit=" +
          currViewportType.value +
          "&width=" +
          currViewportW.value +
          "&height=" +
          currViewportH.value
      );
    };
    const cm = ref(28.3);
    const mm = ref(2.83);
    const width = ref();
    const height = ref();
    const onCreateDesignOnScenes = (item: {
      width: number;
      heigh: number;
      unit: any;
      id: string;
    }) => {
      // vipCheck()
      if (item.unit === "cm") {
        width.value = (item.width * cm.value).toFixed(2);
        height.value = (item.heigh * cm.value).toFixed(2);
      } else if (item.unit === "mm") {
        width.value = (item.width * mm.value).toFixed(2);
        height.value = (item.heigh * mm.value).toFixed(2);
      } else {
        width.value = item.width;
        height.value = item.heigh;
      }
      store.commit(
        MutationTypes.SET_VIEWPORT_RATIO,
        Number(item.heigh) / Number(item.width)
      );
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTH, Number(width.value));
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHT, Number(height.value));
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_WIDTHS, Number(item.width));
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_HEIGHTS, Number(item.heigh));
      store.commit(MutationTypes.SET_VIEWPORT_RATIO_TYPE, item.unit ? item.unit : "px");
      store.commit(MutationTypes.SET_CRATED_DESIGN_MODAL_STATE, false);
      router.push("/editor?mode=" + "create&cid=" + item.id);
    };
    const getScenesList = async () => {
      const params = {
        pageNumber: 1,
        pageSize: 500,
      };
      const res = await EditorService.getScenesList(params);
      const list = ref([]);
      res.data.data.forEach((item: any) => {
        item.checked = false;
        if (item.display) {
          list.value.push(item as never);
        }
      });
      scenesList.value = list.value;
      // console.log( res.data.data, templateList.value, ' templateList.value')
    };
    const template: string | null = window.localStorage.getItem("template");
    if (template) {
      categoryList.value = JSON.parse(template);
    }
    // const vipCheck = async () => {
    //   const loginParams = {
    //     type: 'ppt_content_count',
    //     code: '',
    //   }
    //   const res = await UserService.vipCheck(loginParams)
    //   if (res.data.state === 2) {
    //     message.success(res.data.msg)
    //   }
    //   else {
    //     message.error(res.data.msg)
    //   }
    // }
    return {
      visible,
      collapse,
      sucaiCollapse,
      viewportType,
      currViewportType,
      currViewportW,
      currViewportH,
      currRouter,
      showCreateDesign,
      closeModal,
      onCollapseOpeate,
      onSucaiCollapseOpeate,
      onCreateDesign,
      onCreateDesignOnScenes,
      scenesList,
      categoryList,
    };
  },
});
